import { render, staticRenderFns } from "./NewIncidence.vue?vue&type=template&id=a08c48a8&"
import script from "./NewIncidence.vue?vue&type=script&lang=js&"
export * from "./NewIncidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports